export class Permissions {
    constructor(
        public canAdd: boolean,
        public canEdit: boolean,
        public canShow: boolean,
        public canDelete: boolean,
        public hasBudgetPermission: boolean,
        public hasAllWorklogsPermission: boolean,
        public hasIssuesNotAssignedPermission: boolean,
        public hasIsToTfsPermission: boolean,
        public hasCustomerBlockingPermission: boolean,
        public hasExtIssuesRcpReportPermission:boolean,
        public hasExtIssuesRcpReportForeignPayerPermission:boolean,
        public customerId: number
    ) {
    }
}

export interface HasPermissions {
    permissions: Permissions;

    /**
     * 
     * 1. Add (private permissionService: PermissionsService) to constructor
     * 2. Implement this method with below line: 
     *  
     * this.permissions = this.permissionService.getUserPermissions(claimType);
     * 
     * 3. Add this.setPermissions(claimType) to ngOnInit() mtehod
     * @param claimType: Type of permission like User, Project, etc.
     */
    setPermissions(claimType: string): void;
}